import _regeneratorRuntime from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { AbilityBuilder } from '@casl/ability';
import { abilitiesPlugin } from '@casl/vue';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, rules;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            rules = sessionStorage.getItem('RULES_USER'); // Permiso por defecto.

            Vue.use(abilitiesPlugin, AbilityBuilder.define(function (can) {// can('read', 'all')
            }));

            if (rules) {
              rules = JSON.parse(rules);

              if (rules instanceof Array && rules.length) {
                Vue.prototype.$ability.update(rules);
              }
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();